module.exports = flarum.core.compat['components/Modal'];